import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CTA() {
  return <section id="contacto" className="relative w-full border-t border-white/[0.06] py-28 sm:py-32 lg:py-40" data-id="element-44" data-mp="1lg9lqioa7ura">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-45" data-mp="1zg14sxtno1c5">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative overflow-hidden rounded-4xl border border-white/[0.08] bg-[#131317] px-8 py-20 text-center sm:px-20 sm:py-28" data-id="element-46" data-mp="1uirap4vbn1hz">
          <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
          background: 'radial-gradient(70% 120% at 50% 0%, rgba(37,99,246,0.22), transparent 65%), radial-gradient(60% 100% at 50% 110%, rgba(139,92,246,0.22), transparent 60%)'
        }} data-id="element-47" data-mp="1bqq1p9ou1uuu" />
          <div className="relative mx-auto max-w-2xl" data-id="element-48" data-mp="33caj1mpasqfb">
            <h2 className="text-3xl font-semibold leading-[1.15] tracking-[-0.025em] text-white sm:text-[2.9rem]" data-id="element-49" data-mp="38cojaiknqw2s">
              Empezá hoy a construir un negocio más inteligente.
            </h2>
            <p className="mx-auto mt-7 max-w-xl text-[16px] font-light leading-relaxed text-white/50" data-id="element-50" data-mp="3h61i215ekrws">
              Recursos, estrategias e inteligencia artificial en un solo lugar.
              Elegí tu producto y empezá a implementar esta semana.
            </p>
            <a href="#productos" className="group brand-gradient-bg mt-12 inline-flex items-center gap-2 rounded-full px-7 py-4 text-sm font-medium text-white shadow-[0_24px_60px_-20px_rgba(90,80,246,0.9)] transition-all duration-300 hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50" data-id="element-51" data-mp="2tg775p4n9df6">
              Ver Productos
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-52" data-mp="29s7moyxot5on" />
            </a>
            <p className="mt-8 text-[12.5px] font-light text-white/35" data-id="element-53" data-mp="2jqdj510q5jm4">
              creativodigital.shop · @creativodigitalstudio
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}